<template>
  <div>
    reset password
  </div>
</template>
<script>
import VueCookie from "vue-cookie";
export default {
  props: ["id"],
  mounted() {
    VueCookie.set("reset-token", this.id);
    this.$router.push("/");
  }
};
</script>
